import React from 'react'
import { withIcon } from '../../withIcon'

function CaretUpOutlineIcon (props) {
  const {
    size = '24px',
    color = 'currentColor',
  } = props

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path fillRule="evenodd" clipRule="evenodd" d="M11.1831 7.44702C11.4272 7.19507 11.8229 7.19507 12.067 7.44702L18.067 13.6406C18.2457 13.8251 18.2992 14.1026 18.2024 14.3437C18.1057 14.5847 17.8778 14.7419 17.625 14.7419L5.62502 14.7419C5.37223 14.7419 5.14433 14.5847 5.04759 14.3437C4.95085 14.1026 5.00433 13.8251 5.18308 13.6406L11.1831 7.44702ZM7.1339 13.4516L16.1161 13.4516L11.625 8.81561L7.1339 13.4516Z" fill={color}/>
    </svg>
  )
}

export default withIcon(CaretUpOutlineIcon)
